import { TechnicalInterventionStatus } from '@savgroup-front-common/types';

import { safeFormattedIntlString } from '../safeFormattedIntlString';

import messages from './messages';

export const formatTechnicalInterventionStatus = (
  status?: TechnicalInterventionStatus,
) => {
  const message = messages[status as keyof typeof messages];

  if (!message) {
    return safeFormattedIntlString(messages.None);
  }

  return safeFormattedIntlString(message);
};
